<template>
    <el-col :span="4" :lg="6" :push="1">
        <el-dialog width="1000" title="Sales Order Sample Data" :visible="dialogTableVisible" @close="$emit('onClose')">
            <el-table :data="gridData">
                <el-table-column property="number" label="Number" width="80"></el-table-column>
                <el-table-column property="customerName" label="Customer Name" width="100"></el-table-column>
                <el-table-column property="date" label="Date" width="80"></el-table-column>
                <el-table-column property="validDate" label="Valid Date" width="80"></el-table-column>
                <el-table-column property="reference" label="Reference" width="80"></el-table-column>
                <el-table-column property="currency" label="Currency" width="80"></el-table-column>
                <el-table-column property="exchangeRate" label="Exchange Rate" width="80"></el-table-column>
                <el-table-column property="taxType" label="Tax Type" width="80"></el-table-column>
                <el-table-column property="item" label="Item" width="80"></el-table-column>
                <el-table-column property="description" label="Description" width="80"></el-table-column>
                <el-table-column property="quantity" label="Qty" width="80"></el-table-column>
                <el-table-column property="unitMeasurement" label="U/M" width="80"></el-table-column>
                <el-table-column property="price" label="Price" width="80"></el-table-column>
                <el-table-column property="discountType" label="Discount Type" width="80"></el-table-column>
                <el-table-column property="discountAmount" label="Discount Amount" width="80"></el-table-column>
                <el-table-column property="salesAccount" label="Sales Account" width="80"></el-table-column>
                <el-table-column property="tax" label="Tax" width="80"></el-table-column>
                <el-table-column property="department" label="Department" width="80"></el-table-column>

            </el-table>
            <div style="text-align: center">
                <p>Sales Order date format should be <b>MM/dd/yyyy</b> format. You can download sample file <a href="https://s3.amazonaws.com/workforcetrack/000000000000/invoice-import-app/public/Sales_Order_Import_Template.csv">here</a> </p>
            </div>
        </el-dialog>
    </el-col>
</template>


<script>
    export default {
        props: {
            dialogTableVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                gridData: [
                    {
                        number: 'SO0001',
                        customerName: 'John Smith',
                        date: '01/01/2019',
                        validDate: '01/30/2019',
                        reference: 'reference test',
                        currency: 'USD',
                        exchangeRate: '1',
                        taxType: 'Tax Exclusive',
                        item: 'PD0001',
                        description: 'Test description',
                        quantity: '1',
                        unitMeasurement: 'Each',
                        price: '100',
                        discountType: 'Fixed Amount',
                        discountAmount: '50',
                        salesAccount: '4000',
                        tax: 'VAT(0.05%)',
                        department: 'Sales Department'
                    },
                    {
                        number: 'SO0002',
                        customerName: 'Adam Smith',
                        date: '01/02/2019',
                        validDate: '01/30/2019',
                        reference: 'reference test',
                        currency: 'USD',
                        exchangeRate: '1',
                        taxType: 'Tax Inclusive',
                        item: 'PD0002',
                        description: 'Test description',
                        quantity: '1',
                        unitMeasurement: 'Each',
                        price: '100',
                        discountType: 'Fixed Amount',
                        discountAmount: '50',
                        salesAccount: '4000',
                        tax: 'VAT(0.00%)',
                        department: 'IT Department'
                    },
                    {
                        number: 'SO0003',
                        customerName: 'John Smith',
                        date: '01/03/2019',
                        validDate: '01/30/2019',
                        reference: 'reference test',
                        currency: 'USD',
                        exchangeRate: '1',
                        taxType: 'Tax Exclusive',
                        item: 'PD0003',
                        description: 'Test description',
                        quantity: '1',
                        unitMeasurement: 'Each',
                        price: '100',
                        discountType: 'Fixed Amount',
                        discountAmount: '50',
                        salesAccount: '4000',
                        tax: 'VAT(0.00%)',
                        department: 'Sales Department'
                    },
                    {
                        number: 'SO0004',
                        customerName: 'John Smith',
                        date: '01/03/2019',
                        validDate: '01/30/2019',
                        reference: 'reference test',
                        currency: 'SAR',
                        exchangeRate: '0.075',
                        taxType: 'Tax Inclusive',
                        item: 'PD0004',
                        description: 'Test description',
                        quantity: '1',
                        unitMeasurement: 'Each',
                        price: '100',
                        discountType: 'Percentage',
                        discountAmount: '5',
                        salesAccount: '4000',
                        tax: 'VAT(0.00%)',
                        department: 'Admin Department'
                    }

                ],
                dialogFormVisible: false
            };
        }
    };
</script>


// WEBPACK FOOTER //
// SalesOrderPopup.vue?b42dfa1c